var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowAccordionDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8997 0.679827C10.9667 0.746792 11.0001 0.8238 11.0001 0.910854C11.0001 0.997908 10.9667 1.07492 10.8997 1.14188L6.21889 5.82268C6.15193 5.88965 6.07492 5.92313 5.98786 5.92313C5.90081 5.92313 5.8238 5.88965 5.75684 5.82268L1.07603 1.14188C1.00907 1.07492 0.975586 0.997908 0.975586 0.910854C0.975586 0.8238 1.00907 0.746792 1.07603 0.679827L1.57826 0.177595C1.64523 0.11063 1.72224 0.0771484 1.80929 0.0771484C1.89635 0.0771484 1.97335 0.11063 2.04032 0.177595L5.98786 4.12514L9.93541 0.177595C10.0024 0.11063 10.0794 0.0771484 10.1664 0.0771484C10.2535 0.0771484 10.3305 0.11063 10.3975 0.177595L10.8997 0.679827Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowAccordionDown);
export default __webpack_public_path__ + "static/media/arrow-accordion-down.2a9bf8f497f450ba6a93d82edb1c0b80.svg";
export { ForwardRef as ReactComponent };